import React, { useContext } from "react";
import "date-fns";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { NavLink } from "react-router-dom";
// import { ReactComponent as Loader } from "../../../LearningResources/Assement/Questions/Loader/Loader.svg";
import { ReactComponent as Loader } from "../../images/Loader.svg";
import { GlobalContext } from "../../context/GlobalState";

const useStyles = makeStyles((theme) => ({
  tableContainer: {},
  table: {
    minWidth: "auto",
  },
  formControl: {
    margin: theme.spacing(2),
    minWidth: 280,
  },
  tableRow: {
    textDecoration: "none",
    "& > td": {
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#5ce0d2 !important",
    },
  },
  tableHeading: {
    " & > th": {
      fontWeight: "bolder",
      fontSize: "1.02em",
    },
  },
}));

const checkstatus = (test) => {
  //When test has started but has not been sbumitted yet
  /*if (
    test.to > new Date().toISOString() &&
    test.from < new Date().toISOString()
  ) {
    return "In Progress";
  }

  //When test has not started yet
  if (test.from > new Date().toISOString()) {
    return "Assigned";
  }*/
  const now = new Date().getTime();
  const from = new Date(test.from).getTime();
  const to = new Date(test.to).getTime();


  // Test is currently active (started but not yet ended)
  if (from <= now && to >= now) {
    return "In Progress";
  }

  // Test has not started yet
  if (from > now) {
    return "Assigned";
  }

  return "Completed";
};

const convertArrayToString = (array) => {
  if (!array || !array.length) {
    return "N/A";
  }
  array = array && array.map((item) => item.name);
  return array.join(", ");
};

const ReportsTable = ({ rows, loading }) => {
  const { userDetails } = useContext(GlobalContext);
  const classes = useStyles();

  return (
    <div className={classes.tableContainer}>
      {!loading ? (
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow className={classes.tableHeading}>
                <TableCell align="center">No</TableCell>
                {userDetails?.role !== "teacher" ? (
                  <TableCell align="center">Teacher</TableCell>
                ) : null}
                <TableCell align="center">Grade</TableCell>
                <TableCell align="center">Subject</TableCell>
                <TableCell align="center">Chapters</TableCell>
                <TableCell align="center">Topics</TableCell>
                <TableCell align="center">Test</TableCell>
                <TableCell align="center">Type</TableCell>
                <TableCell align="center">Questions</TableCell>
                <TableCell align="center">Marks</TableCell>
                <TableCell align="center">Duration</TableCell>
                <TableCell align="center">Start Date</TableCell>
                <TableCell align="center">End Date</TableCell>
                <TableCell align="center">Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows && rows.length ? (
                rows.map((row, index) => (
                  <TableRow
                    key={`${row.subject}${index}`}
                    variant="button"
                    component={NavLink}
                    to={
                      ["Done", "Assigned"].includes(checkstatus(row))
                        ? "#"
                        : `/report/reportcard/${row._id}`
                    }
                    className={classes.tableRow}
                    style={{
                      backgroundColor: index % 2 ? "#5ce0d2" : "white",
                    }}
                  >
                    <TableCell scope="row" align="center">
                      {index + 1}
                    </TableCell>
                    {userDetails?.role !== "teacher" ? (
                      <TableCell align="center">
                        {row?.creatorId?.name || ""}
                      </TableCell>
                    ) : null}
                    <TableCell scope="row" align="center">
                      {row.sections &&
                        row.sections
                          .map(
                            (section) =>
                              `${section?.grade || ""}-${
                                section?.section || ""
                              }`
                          )
                          .join(",")}
                    </TableCell>
                    <TableCell scope="row" align="center">
                      {row.subjectId.name}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ wordBreak: "break-word"}}
                      dangerouslySetInnerHTML={{
                        __html: convertArrayToString(row.questionSet.chapters),
                      }}
                    ></TableCell>
                    <TableCell
                      align="center"
                      style={{ wordBreak: "break-word" }}
                      dangerouslySetInnerHTML={{
                        __html: convertArrayToString(row.questionSet.topics),
                      }}
                    ></TableCell>

                    <TableCell scope="row" align="center">
                      {row.questionSet.title}
                    </TableCell>
                    <TableCell align="center">{row.testType}</TableCell>
                    <TableCell scope="row" align="center">
                      {row.questionSet.totalQuestions}
                    </TableCell>
                    <TableCell align="center">
                      {row.questionSet.totalMarks}
                    </TableCell>
                    <TableCell align="center">
                      {Math.floor(row.duration / 3600000)}h{" "}
                      {(row.duration % 3600000) / 60000}m
                    </TableCell>
                    <TableCell align="center">
                      {row.from.split("T")[0]}
                    </TableCell>

                    <TableCell align="center">{row.to.split("T")[0]}</TableCell>

                    <TableCell align="center">{checkstatus(row)}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell scope="row" align="center">
                    -
                  </TableCell>
                  <TableCell scope="row" align="center">
                    -
                  </TableCell>
                  <TableCell align="center">-</TableCell>
                  <TableCell align="center">-</TableCell>
                  <TableCell align="center">-</TableCell>
                  <TableCell align="center">-</TableCell>
                  <TableCell align="center">-</TableCell>
                  <TableCell align="center">-</TableCell>
                  <TableCell align="center">-</TableCell>
                  <TableCell align="center">-</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Loader />
        // "Hello"
      )}
    </div>
  );
};

export default ReportsTable;
